module.exports = __webpack_public_path__ + "resources/img/user.d0ef2201.png";